import { createCowLogger } from '@cowprotocol/common-utils'

export const logCaptcha = createCowLogger('Captcha')
